import { Component } from 'react'
import Table from 'rc-table'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { Toast, Button } from '@vzmi/shp_shared_compo'

import styles from './ItemSpecDetailTable.css'

const CopyAllIdsBtn = props => {
  const {
    label,
    textToCopy,
    successMsg = '複製成功'
  } = props
  return (
    <CopyToClipboard
      text={textToCopy}
      onCopy={() => Toast.success(successMsg)}
    >
      <Button
        type='button'
        link
        size='medium'
        iconType='gallery'
      >
        {label}
      </Button>
    </CopyToClipboard>
  )
}

export const ModelItemSpec = props => {
  const { modelSpec, itemSpec } = props
  return (
    <div className={styles.itemsInfo}>
      <p className={styles.modelSpec}>{modelSpec}</p>
      <p className={styles.itemSpec}>{itemSpec}</p>
    </div>
  )
}

export const ItemIdLabel = props => {
  const { itemId } = props
  return (
    <div className={styles.productNoInfo} >
      {itemId}
    </div>
  )
}

const CopySingleItemIdBtn = props => {
  const {
    itemId,
    successMsg = '複製成功'
  } = props
  return (
    <CopyToClipboard
      text={itemId}
      onCopy={() => Toast.success(successMsg)}
    >
      <Button
        className={styles.copyButton}
        data-role='copy-product-number-button'
        size='medium'
        buttonType='outline'
      >
        複製編號
      </Button>
    </CopyToClipboard>
  )
}

class ItemSpecDetailTable extends Component {
  getTableData = () => {
    const { itemSpecs } = this.props
    return itemSpecs.map((spec, idx) => {
      const {
        modelSpec,
        itemSpec,
        itemId
      } = spec

      return ({
        key: idx,
        modelItemSpec: <ModelItemSpec
          modelSpec={modelSpec}
          itemSpec={itemSpec}
        />,
        itemId: <ItemIdLabel itemId={itemId} />,
        copyBtn: <CopySingleItemIdBtn itemId={itemId} />
      })
    })
  }

  getTableColumns = () => {
    const { joinedItemId } = this.props
    return [{
      title: '規格項目',
      dataIndex: 'modelItemSpec',
      className: styles.items,
      width: 130
    }, {
      title: '商品編號',
      dataIndex: 'itemId',
      className: styles.productNo,
      width: 130
    }, {
      title: (
        <CopyAllIdsBtn
          label='複製全部'
          textToCopy={joinedItemId}
        />
      ),
      dataIndex: 'copyBtn',
      className: styles.copyAll,
      width: 130
    }]
  }

  render () {
    return (
      <div className={styles.productDetailTable}>
        <Table
          columns={this.getTableColumns()}
          data={this.getTableData()}
          pagination={false}
          scroll={{ y: 560 }}
        />
      </div>
    )
  }
}

export default ItemSpecDetailTable

export const DetailTable = props => {
  const {
    columns,
    data
  } = props

  return (
    <div className={styles.productDetailTable}>
      <Table
        columns={columns}
        data={data}
        pagination={false}
      />
    </div>
  )
}
